import React, { useState } from 'react';
import logo from './img/nav-logo.png';
import './Navbar.css';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <a href="/" className="logo">
                    <img src={logo} className="navbar-logo" alt="NAOI 2025" />
                </a>
            </div>
            <div>
                <div className={`navbar-center ${menuOpen ? 'open' : ''}`}>
                <ul className="nav-links">
                    <li>
                        <a href="/regulations">Regulations</a>
                    </li>
                    <li>
                        <a href="/organization">Organization</a>
                    </li>
                    <li>
                        <a href="/teams">Participants</a>
                    </li>
                    <li>
                        <a href="/tasks">Tasks</a>
                    </li>
                    <li>
                        <a href="/results">Results</a>
                    </li>
                </ul>
            </div>
            </div>
            <div className="navbar-right">
                <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
